/**
 * Generated city route paths from CITY_AGENCY_PAGES
 * Used by App.tsx to register city landing page routes dynamically.
 */
import { CITY_AGENCY_PAGES } from '@/data/city-agency-pages';

export const ALL_CITY_ROUTE_SLUGS = Array.from(
  new Set(Object.values(CITY_AGENCY_PAGES).map((city) => city.slug))
).sort();
